import React, { useCallback } from "react";

import { useAuthContext } from "../../../auth";
import { useDataLayer } from "../../../hooks/use-data-layer";
import { useHeaderMenu } from "../../../hooks/use-header-menu";
import { GoogleAnalyticsEvent } from "../../../utils/analytics";
import { Button } from "../../buttons/button";

export function LoginButton() {
  const { labels } = useHeaderMenu();
  const { login, checking } = useAuthContext();

  const { pushEvent } = useDataLayer();
  const handleOnClick = useCallback(() => {
    pushEvent({
      event: GoogleAnalyticsEvent.Login,
    });
    login({});
  }, [login, pushEvent]);

  return (
    <Button variant="primary" disabled={checking} className="w-fit" onClick={handleOnClick}>
      {labels["header-menu-personal-area-login-cta"]}
    </Button>
  );
}
